/* `/agents/cards/{id}` — what an agent's link shows before anyone signs in: its name and
   avatar, and whether it answers yet. Public: the link is the permission (modules/agents). */
import { useQuery } from "@tanstack/react-query";

import { client } from "@/shared/api/client";
import { unwrap, type Envelope } from "@/shared/api/envelope";

export interface ExtensionLink {
  agent: { id: string; name: string; seed: string | null; hue: number | null };
  /** false while it has no published version */
  live: boolean;
}

export const linkKeys = {
  all: ["extension-link"] as const,
  one: (id: string) => [...linkKeys.all, id] as const,
};

export async function getExtensionLink(agentId: string): Promise<ExtensionLink> {
  return unwrap(await client.get<Envelope<ExtensionLink>>(`/agents/cards/${agentId}`));
}

export function useExtensionLink(agentId: string) {
  return useQuery({ queryKey: linkKeys.one(agentId), queryFn: () => getExtensionLink(agentId), retry: false, meta: { silent: true } });
}
